export default "/images/loader.png?089c46ee9a023627f54736185a4ac5a6";